import screenTooSmallLocales from "@/lib/localization/ScreenTooSmall.locales";
import { Body, useLocales } from "@/lib/main";
import { CSSProperties } from "react";

export default function ScreenTooSmall() {
  const l = useLocales();

  const styles: CSSProperties = {
    width: "100vw",
    height: "100vh",

    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "var(--spacing-lg)",

    padding: "var(--spacing-lg)",
  };

  return (
    <div style={styles}>
      <Body textAlign="center" size="lg" color="secondary">
        {l(screenTooSmallLocales.message)}
      </Body>
    </div>
  );
}
